module.exports = __webpack_public_path__ + "static/img/stay-option-icon-charger.ddd0aeb2.svg";